<template>
  <div class="dashboard-main-content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="form-box">
            <div class="form-title-wrap">
              <div class="d-flex align-items-center justify-content-end">
                <a href="javascript:void(0)" @click="createCruise" class="theme-btn theme-btn-small">
                  <i class="la la-plus mr-1"></i>
                  Cruise Yarat
                </a>
              </div>
            </div>
            <div class="form-content pb-2">

              <h3 class="title">Cruises</h3>
              <p class="font-size-14" v-if="cruiseList != null">{{ cruiseList.length }} cruise listeleniyor</p>

              <div class="table-form table-responsive">
                <table class="table">
                  <thead>
                  <tr>
                    <th scope="col">Id</th>
                    <th>Adı</th>
                    <th>Açıklama</th>
                    <th>Aksiyon</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="cruise in cruiseList">
                    <th scope="row"><a :href="basePath+'/cruises/'+cruise.id" >#{{ cruise.id }}</a></th>
                    <th>{{ cruise.name }}</th>
                    <td>{{ cruise.description }}</td>
                    <td>
                      <div class="table-content">
                        <router-link
                            tag="a"
                            :to="'/cruises/'+cruise.id"
                            class="theme-btn theme-btn-small"
                            title=""
                            data-original-title="Edit"
                            :active-class="'active'"
                            exact>
                          <i class="la la-edit"></i>
                        </router-link>

<!--                        <a :href="basePath+'/cruise/detail/'+cruise.id" class="theme-btn theme-btn-small" >-->
<!--                          <i class="la la-edit"></i>-->
<!--                        </a>-->
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CruiseList",
  computed:{
    cruiseList:{
      get(){
        return this.$store.getters.getCruiseList;
      }
    },
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    }
  },
  methods:{
    showDetail(cruise){
      //TODO:Temporary callback
      // this.$store.dispatch("loadCruise",cruise.id)
      this.$store.dispatch("loadCruise")
    },
    createCruise(){
      this.$store.commit("setCruise",{statistics:{}});
      this.$router.push("/cruises/new")
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

</style>